import Login from '../components/Login'
import ForgetPassword from '../components/ForgetPassword'
import Redirect from '../../Shop/containers/Redirect'
import Auth from '../containers/Auth'

export default {
  path: '/',
  name: 'Auth',
  redirect: '/redirect',
  component: Auth,
  children: [{
    path: '/login',
    name: 'Login',
    component: Login,
    props: true
  }, {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
  },
  {
    path: '/redirect',
    name: 'Redirect',
    component: Redirect,
  },]
}



// WEBPACK FOOTER //
// ./src/Auth/route/index.js